import React, { useState, useEffect, useCallback } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate, useParams } from 'react-router-dom';
import './App.css';
import LandingPage from './pages/LandingPage';
import SurveyPage from './pages/SurveyPage';
import ResultsPage from './pages/ResultsPage';
import OpsLogin from './pages/ops/OpsLogin';
import OpsDashboard from './pages/ops/OpsDashboard';

function App() {
  return (
    <Router>
      <div className="min-h-screen bg-gray-50">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/survey/:sessionId" element={<SurveyPage />} />
          <Route path="/survey/:sessionId/:categoryId" element={<SurveyPage />} />
          <Route path="/results/:sessionId" element={<ResultsPage />} />
          
          {/* Hidden Admin Routes - No links from public site */}
          <Route path="/ops" element={<OpsLogin />} />
          <Route path="/ops/dashboard" element={<OpsDashboard />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
